import React from "react";
export const GlobeIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.8 21C16.3229 21 20.8 16.5228 20.8 11C20.8 5.47715 16.3229 1 10.8 1C5.2772 1 0.800049 5.47715 0.800049 11C0.800049 16.5228 5.2772 21 10.8 21Z"
      stroke="#242533"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M0.800049 11H20.8"
      stroke="#242533"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.8004 1C13.3016 3.73835 14.7231 7.29203 14.8004 11C14.7231 14.708 13.3016 18.2616 10.8004 21C8.29907 18.2616 6.8776 14.708 6.80035 11C6.8776 7.29203 8.29907 3.73835 10.8004 1V1Z"
      stroke="#242533"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
